module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p1"
  }, [_c('PinchInImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPinchIn),
      expression: "showPinchIn"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-mic",
    style: (_vm.toparea_visible),
    attrs: {
      "id": "toparea"
    }
  }, [_c('div', {
    staticClass: "item-wrap flexcenter"
  }, [_c('div', {
    staticClass: "item bgdgray bdgreen w300",
    class: {
      'textmgray': _vm.isTextGray
    },
    attrs: {
      "id": "inputarea"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.inputString) + "\n            "), _c('div', {
    staticClass: "mic-icon",
    class: _vm.scoreNum
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-skip",
    attrs: {
      "id": "ssbutton"
    },
    on: {
      "click": _vm.skipQuestion
    }
  })])]), _vm._v(" "), (_vm.isEnvironmentPc()) ? [_c('div', {
    staticClass: "cards-container active-type2 card-voice"
  }, [_vm._l((_vm.acts), function(actblock, index) {
    return [_c('div', {
      key: index,
      class: actblock[0].layoutClass
    }, [_vm._l((actblock), function(act, index2) {
      return [_c('div', {
        key: index2,
        class: act.active,
        attrs: {
          "id": act.active_id,
          "name": act.sound
        }
      }, [_c('p', {
        attrs: {
          "id": act.text_id
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getText(act))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "image"
      }, [_c('img', {
        attrs: {
          "src": act.image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        style: (act.sbutton_visible),
        attrs: {
          "id": act.sbutton_id
        }
      }), _vm._v(" "), _c('div', {
        attrs: {
          "id": act.correct_id
        }
      })])])]
    })], 2)]
  })], 2)] : [_c('div', {
    staticClass: "cards-container swiper-container swiper-container1 active-type2 card-voice"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.acts), function(actblock, index) {
    return [_c('div', {
      key: index,
      class: actblock[0].layoutClass
    }, [_c('div', {
      staticClass: "swiper-container swiper-container2"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_vm._l((actblock), function(act, index2) {
      return [_c('div', {
        key: index2,
        class: act.active,
        attrs: {
          "id": act.active_id,
          "name": act.sound
        }
      }, [_c('p', {
        attrs: {
          "id": act.text_id
        },
        domProps: {
          "innerHTML": _vm._s(_vm.getText(act))
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "image",
        on: {
          "touchstart": function($event) {
            return _vm.onTouchStart(act.image)
          },
          "touchend": function($event) {
            return _vm.onTouchEnd()
          },
          "touchmove": function($event) {
            return _vm.onTouchEnd()
          }
        }
      }, [_c('img', {
        attrs: {
          "src": act.image
        }
      })]), _vm._v(" "), _c('button', {
        staticClass: "icon-voice",
        style: (act.sbutton_visible),
        attrs: {
          "id": act.sbutton_id
        }
      }), _vm._v(" "), _c('div', {
        attrs: {
          "id": act.correct_id
        }
      })])])]
    })], 2)])])]
  })], 2)])]], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d5c12aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-4d5c12aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/P1.vue
// module id = 624
// module chunks = 1